/* eslint-disable import/prefer-default-export */
import React, { FC } from 'react';

import { Checkbox } from '@eika/checkbox';
import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import useTranslation from '../../../../../hooks/useTranslation';
import useFormContext from '../../form/useFormContext';

import './InstantPaymentCheckbox.scss';

interface Props {
    locked?: boolean;
    onChange: (value: boolean) => void;
    error?: string;
}

export const InstantPaymentCheckbox: FC<Props> = ({ onChange, locked, error }) => {
    const translated = useTranslation();
    const { state } = useFormContext();

    return (
        <li>
            <div className="row-button__container instant-payment-checkbox">
                <Checkbox
                    disabled={locked}
                    onClick={() => onChange(!state.immediate)}
                    data-testid="instant-payment-checkbox"
                    checked={!!state.immediate}
                    label={translated.immediatePayment.title}
                />
                {error && <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={error} />}
            </div>
        </li>
    );
};
